import React from 'react';
import { useDropzone } from 'react-dropzone';
import classNames from 'classnames';
import SVGIcon from './SVGIcon';
import { IMAGE_MIME_TYPES } from './Uploader';
import imageIcon from '../icons/non-prefilled/28x28/dropzoneImage.svg';
import styles from './ImageEditorDropZone.module.scss';

interface ImageEditorDropZoneProps {
  onDropImage(file: File): void;
  children: React.ReactNode;
  disabled?: boolean;
}

const ImageEditorDropZone = ({
  onDropImage,
  children,
  disabled,
}: ImageEditorDropZoneProps) => {
  const { getRootProps, isDragActive } = useDropzone({
    accept: IMAGE_MIME_TYPES,
    multiple: false,
    maxSize: 25 * 1000 * 1000,
    disabled,
    onDrop([file]) {
      if (file) {
        onDropImage(file);
      }
    },
  });

  return (
    <div
      {...getRootProps()}
      className={classNames(styles.container, {
        [styles.isHidden]: !isDragActive,
      })}
    >
      <div className={styles.dropZone}>
        <SVGIcon className={styles.dropZoneIcon} size={28}>
          {imageIcon}
        </SVGIcon>
        <div>Drop an image to upload</div>
      </div>
      {children}
    </div>
  );
};

export default ImageEditorDropZone;
